import React from "react";
import { WidgetProps } from "@rjsf/core";
import { TimeRangeDisplay } from "../components/TimeRangeDisplay";
import { dateDataToDate } from "../../../constants/formats";

type TValue = { start?: string, end?: string };

const DateRangePickerDisplay: React.FC<WidgetProps> = (props) => {

  const {
    id,
    value: uknownValue,
    schema,
    formContext
  } = props

  const value: TValue | undefined = uknownValue;

  const schemaFormat = (schema.format as "date" | "time" | "date-time") || "date-time";

  const getValue = (key: keyof TValue) => value && value[key];

  const getDateValue = (key: keyof TValue) => {
    return dateDataToDate(value && value[key], schemaFormat);
  }

  const start = getValue("start");
  const end = getValue("end");

  const startDate = getDateValue("start");
  const endDate = getDateValue("end");

  if (!start || !end) {
    return formContext.emptyField || null
  }

  return (
    <div id={id} className="DateRangePickerDisplay">
      {startDate && endDate ? (
        <TimeRangeDisplay
          start={startDate}
          end={endDate}
        />

      ) : null}
    </div>
  );
}


export default DateRangePickerDisplay;
